import { makeStyles } from "@material-ui/core/styles";
import { max } from "lodash";

export const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.level1,
    margin: "auto 20px",
    flexGrow: "1",
  },
  logo: {
    display: "block",
    padding: "2rem 0 2rem 0",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 100,
  },
  contentContainer: {
    display: "flex",
    justifyContent: "center",
    maxWidth: "1200px",
    margin: "0 auto",
    paddingBottom: "2rem",
  },
  loadingSpinner: {
    display: "flex",
    justifyContent: "center",
  },
  payNowButton: {
    width: "100%",
    fontSize: "1.3rem"
  },
  termsAndConditions: {
    paddingBottom: "1rem"
  },
  ticketId: {
    color: theme.palette.primary?.main,
    fontWeight: "bold",
  },
  paddingLeft: {
    paddingLeft: "1rem",
  },
  flexCenter: {
    display: "flex",
    justifyContent: "center",
  },
  paperContainerLarge: {
    padding: "1.5rem 1rem",
  },
  paperContainer: {
    padding: "1rem",
  },
  searchContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: "1.25em 0"
  },
  searchTerm: {
    marginRight: "2em",
    marginLeft: "2em",
    flexGrow: 1,
  },
  spacing: {
    padding: "1rem 0",
  },
  textEnd: {
    textAlign: "end",
  },
  value: {
    color: theme.palette.primary?.main,
  },
  label: {
    color: theme.palette.text.secondary,
  },
  	image: {
		maxWidth: "65vw",
		maxHeight: "50vh",
        objectFit: "contain",
		border: "1px solid",
		borderColor: theme.palette.text.disabled,
		borderRadius: 3,
		boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
	},
	imageWrapper: {
		alignContent: "center",
		textAlign: "center",
		justifyContent: "center",
		display: "block",
		margin: "0 auto",
    padding: "1rem"
	},
	imageLoading: {
		textAlign: "center",
		padding: 10,
		margin: 10,
		marginTop: "25vh",
		fontSize: "1.5rem",
		color: theme.palette.amano.base.primary.light,
	},
    paperContainerLargeWithText: {
    padding: "1.5rem 1rem",
    textAlign: "center",
		justifyContent: "center"
  }
}));